import ContextMenuModal from './component';
import enhance from './container';

export default enhance(ContextMenuModal);
